import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../../actions/consumer.actions";
import { DataPerProductState } from "../../models/consumer/data-per-product-state";

const initialState: DataPerProductState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.dataPerProductStats.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerActions.dataPerProductStats.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(ConsumerActions.dataPerProductStats.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function dataPerProductReducer(
	state: DataPerProductState | undefined,
	action: Action
): DataPerProductState {
	return reducer(state, action);
}
